import React from 'react'
import { graphql } from 'gatsby';
import HomeView from '../templates/HomeView';

const Index = (props) => {
  return <HomeView {...props}/>
}

export const pageQuery = graphql`
    query HomeQuery {
        allContentfulGlobalSiteData {
            edges {
              node {
                homePageLandingCopy {
                  raw
                }

                homePageLandingVideo {
                  file {
                    url
                  }
                }

                homePageLandingVideoMobile {
                  file {
                    url
                  }
                }
  
                homePageMapIntroHeading{
                  raw
                }
                homePageMapIntroBody{
                  raw
                }

                homePageShareIntroHeading{
                  raw
                }
                homePageShareIntroBody{
                  raw
                }

                homePageSeo {
                  title
                  description {
                    description
                  }
                  image {
                    file {
                      url
                    }
                  }
                }
                homePageGivingTuesdayCopy {
                  raw
                }
                homePageEmailSignupCopy {
                  raw
                }

                homePageEmailSignupBody {
                  raw
                }
              }
            }
        }


        orgsAtlanta: allContentfulOrganization(sort: {fields: name}, filter: {city: {eq: "Atlanta"}}) {
          edges {
            node {
              ...Organization
            }
          }
        }

        orgsChicago: allContentfulOrganization(sort: {fields: name}, filter: {city: {eq: "Chicago"}}) {
          edges {
            node {
              ...Organization
            }
          }
        }

        orgsPhiladelphia: allContentfulOrganization(sort: {fields: name}, filter: {city: {eq: "Philadelphia"}}) {
          edges {
            node {
              ...Organization
            }
          }
        }

        orgsLA: allContentfulOrganization(sort: {fields: name}, filter: {city: {eq: "LA"}}) {
          edges {
            node {
              ...Organization
            }
          }
        }

        orgsBuffalo: allContentfulOrganization(sort: {fields: name}, filter: {city: {eq: "Buffalo"}}) {
          edges {
            node {
              ...Organization
            }
          }
        }

        orgsDetroit: allContentfulOrganization(sort: {fields: name}, filter: {city: {eq: "Detroit"}}) {
          edges {
            node {
              ...Organization
            }
          }
        }

    }
`

export default Index;